import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CreateModuleGroupMemberSuccess } from 'app/library/module-group-member/actions';
import { EntityState } from 'app/projects/entity/src/lib/models/entity.state';
import {
    AddModuleGroups,
    CreateModuleGroup,
    CreateModuleGroupFailure,
    CreateModuleGroupSuccess,
    DeleteModuleGroup,
    DeleteModuleGroupFailure,
    DeleteModuleGroupSuccess,
    FetchModuleGroup,
    FetchModuleGroupFailure,
    FetchModuleGroupSuccess,
    FetchModuleGroups,
    FetchModuleGroupsFailure,
    FetchModuleGroupsSuccess,
    LeaveGroup,
    LeaveGroupFailure,
    LeaveModuleGroupSuccess,
    SetModuleGroup,
    SetModuleGroups,
    UnsetModuleGroup,
    UpdateModuleGroup,
    UpdateModuleGroupFailure,
    UpdateModuleGroupSuccess,
    UploadGroupImageFailure,
} from '../actions';
import { UploadGroupImage, UploadGroupImageSuccess } from '../actions/index';
import { ModuleGroupApiService } from '../service/module-group.api-service';
import { ModuleGroup } from './module-group';
import { ModuleGroupStateModel } from './module-group.state-model';

@State<ModuleGroupStateModel>({
    name: 'moduleGroup',
    defaults: new ModuleGroupStateModel(),
})
@Injectable()
export class ModuleGroupState extends EntityState<ModuleGroup> {
    @Selector()
    static getEntity(state: ModuleGroupStateModel, id: string = state.item): ModuleGroup {
        if (!state.map) {
            return null;
        }

        return state.map.get(id) || null;
    }

    @Selector()
    static getEntities(state: ModuleGroupStateModel): ModuleGroup[] {
        if (!state.map) {
            return null;
        }

        return Array.from(state.map.values());
    }

    constructor(private _moduleGroupApiService: ModuleGroupApiService) {
        super(null, 0);
    }

    @Action(AddModuleGroups)
    addEntities(ctx: StateContext<ModuleGroupStateModel>, action: AddModuleGroups): void {
        this._addEntities(ctx, action);
    }

    @Action(SetModuleGroup)
    setEntity(ctx: StateContext<ModuleGroupStateModel>, action: SetModuleGroup): void {
        this._setEntity(ctx, action, AddModuleGroups);
    }

    @Action(UnsetModuleGroup)
    unsetEntity(ctx: StateContext<ModuleGroupStateModel>): void {
        this._unsetEntity(ctx);
    }

    @Action(CreateModuleGroup)
    createEntity(ctx: StateContext<ModuleGroupStateModel>, action: CreateModuleGroup): void {
        this._createEntity(ctx, action, CreateModuleGroupSuccess, CreateModuleGroupFailure, AddModuleGroups, null, this._moduleGroupApiService.create(action.payload)).then(
            () => {}
        );
    }

    @Action(UpdateModuleGroup)
    updateEntity(ctx: StateContext<ModuleGroupStateModel>, action: UpdateModuleGroup): void {
        this._updateEntity(ctx, action, UpdateModuleGroupSuccess, UpdateModuleGroupFailure, AddModuleGroups, this._moduleGroupApiService.update(action.payload)).then(() => {});
    }

    @Action(DeleteModuleGroup)
    deleteEntity(ctx: StateContext<ModuleGroupStateModel>, action: DeleteModuleGroup): void {
        this._moduleGroupApiService.delete(action.payload.id, action.payload.notify).subscribe(
            () => {
                ctx.dispatch(new DeleteModuleGroupSuccess(action.payload.id));
            },
            (error) => {
                ctx.dispatch(new DeleteModuleGroupFailure());
            }
        );
    }

    @Action(FetchModuleGroup)
    fetchEntity(ctx: StateContext<ModuleGroupStateModel>, action: FetchModuleGroup): void {
        this._fetchEntity(ctx, action, FetchModuleGroupSuccess, FetchModuleGroupFailure, AddModuleGroups, SetModuleGroup, this._moduleGroupApiService.read(action.payload)).then(
            () => {}
        );
    }

    @Action(FetchModuleGroupSuccess)
    fetchEntitySuccess(ctx: StateContext<ModuleGroupStateModel>, action: FetchModuleGroupSuccess): void {
        this._fetchEntitySuccess(ctx, action);
    }

    @Action(FetchModuleGroupFailure)
    fetchEntityFailure(ctx: StateContext<ModuleGroupStateModel>, action: FetchModuleGroupFailure): void {
        this._fetchEntityFailure(ctx, action);
    }

    @Action(SetModuleGroups)
    setEntities(ctx: StateContext<ModuleGroupStateModel>, action: SetModuleGroups): void {
        throw new Error('Method not implemented.');
    }

    @Action(FetchModuleGroups)
    fetchEntities(ctx: StateContext<ModuleGroupStateModel>): void {
        throw new Error('Method not implemented.');
    }

    @Action(FetchModuleGroupsSuccess)
    fetchEntitiesSuccess(ctx: StateContext<ModuleGroupStateModel>): void {
        throw new Error('Method not implemented.');
    }

    @Action(FetchModuleGroupsFailure)
    fetchEntitiesFailure(ctx: StateContext<ModuleGroupStateModel>): void {
        throw new Error('Method not implemented.');
    }

    @Action(UploadGroupImage)
    uploadGroupImage(ctx: StateContext<ModuleGroupStateModel>, action: UploadGroupImage): void {
        this._moduleGroupApiService.uploadImage(action.payload.file, action.payload.id).subscribe(
            (item) => {
                ctx.dispatch(new UploadGroupImageSuccess(item));
            },
            (error: HttpErrorResponse) => {
                ctx.dispatch(new UploadGroupImageFailure());
            }
        );
    }

    @Action(LeaveGroup)
    leaveGroup(ctx: StateContext<ModuleGroupStateModel>, action: LeaveGroup): void {
        this._moduleGroupApiService.leaveGroup(action.payload).subscribe(
            () => {
                ctx.dispatch(new LeaveModuleGroupSuccess(action.payload));
            },
            (error: HttpErrorResponse) => {
                ctx.dispatch(new LeaveGroupFailure());
            }
        );
    }

    @Action(CreateModuleGroupMemberSuccess)
    createModuleGroupMemberSuccess(ctx: StateContext<ModuleGroupStateModel>, action: CreateModuleGroupMemberSuccess): void {
        action.payload.forEach((entity) => {
            ctx.dispatch(new SetModuleGroup(entity.group));
        });
    }
}
